'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, } from 'react';
import { IconTile } from '../IconTile/IconTile';
import { Row } from '../server/layout/Row/index';
import { Stack } from '../server/layout/Stack/index';
import { useInteractive } from '../system/interactive';
import { MOTION } from '../system/motion';
export function List({ children, bordered = true, style, }) {
    const items = Children.toArray(children);
    return (_jsx("div", { style: {
            // `bordered` (default) makes List a standalone MODULE surface — the
            // one shared card treatment (`--surface-module-*`: white bg + soft
            // shadow + faint hairline), identical to `Card`, so every boxed list
            // matches every card. `bordered={false}` makes it transparent with no
            // frame, for when a `Card` already owns the surface around it.
            borderRadius: 'var(--surface-module-radius)',
            border: bordered ? 'var(--surface-module-border)' : 'none',
            boxShadow: bordered ? 'var(--surface-module-shadow)' : 'none',
            background: bordered ? 'var(--surface-module-bg)' : undefined,
            overflow: 'hidden',
            ...style,
        }, children: items.map((c, i) => (_jsx("div", { style: { borderBottom: i < items.length - 1 ? '1px solid var(--border)' : 'none' }, children: c }, i))) }));
}
export function ListItem({ leading, title, subtitle, trailing, onClick, href, danger, linkAs, }) {
    const interactive = !!(onClick || href);
    const Tag = (href ? (linkAs ?? 'a') : 'div');
    const { state, bind } = useInteractive({ onClick });
    return (_jsxs(Row, { as: Tag, gap: "md", align: "center", px: "lg", py: "md", ...(href ? { href } : {}), ...(interactive ? bind : {}), style: {
            cursor: interactive ? 'pointer' : 'default',
            minHeight: 56,
            background: interactive && state.active
                ? 'var(--border)'
                : interactive && state.hover
                    ? 'var(--accent)'
                    : 'transparent',
            transition: MOTION.transition,
            textDecoration: 'none',
            color: 'inherit',
        }, children: [leading && _jsx("div", { style: { flexShrink: 0 }, children: leading }), _jsxs(Stack, { gap: "xs", style: { flex: 1, minWidth: 0 }, children: [_jsx("span", { style: {
                            font: 'var(--type-body)', fontWeight: 600,
                            color: danger ? 'var(--destructive)' : 'var(--foreground)',
                        }, children: title }), subtitle && (_jsx("span", { style: { font: 'var(--type-caption)', color: 'var(--muted-foreground)' }, children: subtitle }))] }), trailing && _jsx("div", { style: { flexShrink: 0, color: 'var(--muted-foreground)' }, children: trailing })] }));
}
export function SettingIcon({ tone = 'neutral', children, }) {
    return _jsx(IconTile, { tone: tone, size: 36, children: children });
}
//# sourceMappingURL=List.js.map